import { useCountUp } from "@/hooks/useCountUp";
import { formatNumber, percentOf } from "@/pages/steps/utils";

interface StepGaugeProps {
  steps: number;
  goal: number;
}

// 원형 게이지 — 숫자는 이전값 → 새값으로 부드럽게 카운트업 된다.
// (SVG 대신 conic-gradient 로 그려 별도 그래픽 파일 없이 처리한다)
export default function StepGauge({ steps, goal }: StepGaugeProps) {
  const shown = useCountUp(steps);
  const pct = percentOf(shown, goal);
  const deg = pct * 3.6;

  return (
    <div className="relative mx-auto h-40 w-40 shrink-0">
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background: `conic-gradient(oklch(var(--primary-500)) ${deg}deg, oklch(var(--background-200)) ${deg}deg)`,
        }}
        aria-hidden="true"
      ></div>
      <div className="absolute inset-[10px] flex flex-col items-center justify-center rounded-full bg-background-50">
        <span className="font-heading text-3xl font-bold tabular-nums text-foreground-950">
          {formatNumber(shown)}
        </span>
        <span className="text-xs text-foreground-500">걸음</span>
        <span className="mt-0.5 text-[11px] text-foreground-400">
          목표 {formatNumber(goal)} · {pct}%
        </span>
      </div>
    </div>
  );
}